/* eslint-disable max-lines, extra-rules/no-commented-out-code,sonarjs/cognitive-complexity */
/* 9fbef606107a605d69c0edbcd8029e5d */
import { withRouter } from 'next/router';
import Head from 'next/head';
import React from 'react';
import dynamic from 'next/dynamic';
import errorBoundary from '@tcp/core/src/components/common/hoc/withErrorBoundary';
import withRefWrapper from '@tcp/core/src/components/common/hoc/withRefWrapper';
import withHotfix from '@tcp/core/src/components/common/hoc/withHotfix';
import PageSlots from '@tcp/core/src/components/common/molecules/PageSlots';
import SeoCopy from '@tcp/core/src/components/features/browse/ProductListing/molecules/SeoCopy/views';
import DynamicModule from '@tcp/core/src/components/common/atoms/DynamicModule';
import BuyItAgainDynamicStore from '@tcp/core/src/components/features/account/BuyItAgain/container/BuyItAgainDynamicStore';
import {
  getQueryParamsFromUrl,
  internalCampaignProductAnalyticsList,
  fireEnhancedEcomm,
  getAPIConfig,
  isCanada,
  getBrandInCaps,
  markRUMTimings,
  internalPromotionFormattedProducts,
  prefetchImportantChunks,
} from '@tcp/core/src/utils';
import { setProp /* productArr */ } from '@tcp/core/src/analytics/utils';
import { DOMAIN } from '@tcp/core/src/constants/brandSpecific.constants';
import pushEventToAdobeAnalytics from '@tcp/core/src/adobeAnalytics/adobe.utils';
import DynamicCountrySelector from '@tcp/web/src/components/features/content/HeaderNew/molecules/CountrySelector/container/DynamicInjectCountrySelector';
import ModuleContainer from '@tcp/core/src/components/common/molecules/ModuleContainer';
import GetCandidSkeleton from '@tcp/core/src/components/common/molecules/GetCandid/views/GetCandidSkeleton';
import LoadingComponent from './LoadingComponent';
import HOMEPAGE_CONSTANTS from '../HomePage.constants';
import { isTier1Device } from '../../../../../utils/device-tiering';
import {
  HomePageWrapperDefaultProps,
  HomePageWrapperPropTypes,
  HomePageViewPropTypes,
  HomePageViewDefaultProps,
} from '../HomePageA.view';
import StyledPageSlotsWrapper from '../HomePage.style';

const CreateAccount = dynamic(
  () =>
    import(
      /* webpackChunkName: "create-account" */ '@tcp/core/src/components/features/account/CreateAccount'
    ),
  { ssr: false }
);
const LoginContainer = dynamic(
  () =>
    import(
      /* webpackChunkName: "login-page" */ '@tcp/core/src/components/features/account/LoginPage'
    ),
  { ssr: false }
);
const GetCandid = dynamic(
  () =>
    import(
      /* webpackChunkName: "get-candid" */ '@tcp/core/src/components/common/molecules/GetCandid/views/GetCandidUpdate'
    ),
  { loading: () => <GetCandidSkeleton /> }
);

// removed module k and L - TICKET - DRP-12474
const modules = {
  moduleA: dynamic(
    () =>
      import(/* webpackChunkName: "moduleA" */ '@tcp/core/src/components/common/molecules/ModuleA'),
    { loading: () => <LoadingComponent /> }
  ),
  moduleB: dynamic(
    () =>
      import(/* webpackChunkName: "moduleB" */ '@tcp/core/src/components/common/molecules/ModuleB'),
    { loading: () => <LoadingComponent /> }
  ),
  moduleD: dynamic(
    () =>
      import(/* webpackChunkName: "moduleD" */ '@tcp/core/src/components/common/molecules/ModuleD'),
    { loading: () => <LoadingComponent /> }
  ),
  moduleJ: dynamic(
    () =>
      import(/* webpackChunkName: "moduleJ" */ '@tcp/core/src/components/common/molecules/ModuleJ'),
    { loading: () => <LoadingComponent /> }
  ),
  moduleM: dynamic(() =>
    import(/* webpackChunkName: "moduleM" */ '@tcp/core/src/components/common/molecules/ModuleM')
  ),
  moduleN: dynamic(
    () =>
      import(/* webpackChunkName: "moduleN" */ '@tcp/core/src/components/common/molecules/ModuleN'),
    { loading: () => <LoadingComponent /> }
  ),
  moduleQ: dynamic(() =>
    import(/* webpackChunkName: "moduleQ" */ '@tcp/core/src/components/common/molecules/ModuleQ')
  ),
  moduleX: dynamic(() =>
    import(/* webpackChunkName: "moduleX" */ '@tcp/core/src/components/common/molecules/ModuleX')
  ),
  moduleT: dynamic(() =>
    import(/* webpackChunkName: "moduleT" */ '@tcp/core/src/components/common/molecules/ModuleT')
  ),
  moduleL: dynamic(() =>
    import(/* webpackChunkName: "moduleL" */ '@tcp/core/src/components/common/molecules/ModuleL')
  ),
  moduleDynamic: dynamic(() =>
    import(
      // eslint-disable-next-line extra-rules/no-commented-out-code
      /* webpackChunkName: "moduleDynamic" */ '@tcp/core/src/components/common/molecules/ModuleDynamic'
    )
  ),
  module2columns: dynamic(
    () =>
      import(
        /* webpackChunkName: "module2columns" */ '@tcp/core/src/components/common/molecules/ModuleTwoCol'
      ),
    { loading: () => <LoadingComponent /> }
  ),
  moduleG: dynamic(() =>
    import(/* webpackChunkName: "moduleG" */ '@tcp/core/src/components/common/molecules/ModuleG')
  ),
  moduleE: dynamic(() =>
    import(/* webpackChunkName: "moduleE" */ '@tcp/core/src/components/common/molecules/ModuleE')
  ),
  outfitCarousel: dynamic(() =>
    import(
      /* webpackChunkName: "outfitCarousel" */ '@tcp/core/src/components/common/molecules/OutfitCarouselModule'
    )
  ),
  module_container: ModuleContainer,
  moduleTabbedCarousel: dynamic(
    () =>
      import(
        /* webpackChunkName: "moduleTabbedCarousel" */ '@tcp/core/src/components/common/molecules/ModuleTabbedCarousel'
      ),
    { loading: () => <LoadingComponent /> }
  ),
  moduleCategory: dynamic(() =>
    import(
      /* webpackChunkName: "moduleCategory" */ '@tcp/core/src/components/common/molecules/ModuleCategory'
    )
  ),
};

const timer = 200;
export class HomePageWrapper extends React.Component {
  constructor(props) {
    super(props);
    const { router } = props;
    const { target } = (router && router.query) || {};
    this.state = {
      showRegister: target === 'register',
      showLogin: target === 'login',
      showRegisterCheckout: target === 'register-checkout',
      hasMounted: false,
    };
  }

  sendAdobePageViewEvent = (pageDataAdobe, User, APIConfig, session) => {
    return new Promise((resolve) => {
      pushEventToAdobeAnalytics('page_view', { pageData: pageDataAdobe, User, APIConfig, session });
      resolve();
    });
  };

  async componentDidMount() {
    const {
      openCountrySelectorModal,
      router,
      isRegisteredUserCallDone,
      getPageLayout,
      isBIAABCustomVariableEnabled,
      isLoggedIn,
      getBIABagPageProducts,
    } = this.props;
    const { pageDataAdobe, User, APIConfig, session } = this.props?.compProps;
    this.setState({ hasMounted: true });

    const apiConfig = getAPIConfig();
    getPageLayout('home', apiConfig);
    if (isBIAABCustomVariableEnabled && isLoggedIn) {
      await BuyItAgainDynamicStore();
      getBIABagPageProducts();
    }
    if (isRegisteredUserCallDone) {
      this.sHomePageAnalyticsVal(router);
    }
    if (router.query.target === 'ship-to') {
      await DynamicCountrySelector();
      openCountrySelectorModal();
    }
    if (router.events) {
      router.events.on('routeChangeComplete', this.handleRouteChangeComplete);
    }
    markRUMTimings();
    prefetchImportantChunks('HOME');
    this.sendAdobePageViewEvent(pageDataAdobe, User, APIConfig, session).then(() => {
      const products = internalCampaignProductAnalyticsList();
      const productsObj = products && internalPromotionFormattedProducts(products);
      pushEventToAdobeAnalytics('promotional_banner_impression', productsObj);
    });
  }

  async componentDidUpdate(prevProps) {
    const {
      router,
      isRegisteredUserCallDone,
      pageName,
      plccOfferTakeOverABTestEnabled,
      isBIAABCustomVariableEnabled,
      isLoggedIn,
      getBIABagPageProducts,
    } = this.props;

    if (
      isRegisteredUserCallDone &&
      isRegisteredUserCallDone !== prevProps.isRegisteredUserCallDone
    ) {
      // adding a timeout so that the landing brand cookie is dropped and avoid race conditions
      const analyticsTimer = setTimeout(() => {
        this.sHomePageAnalyticsVal(router);
        clearTimeout(analyticsTimer);
      }, timer);
    }
    if (prevProps.isLoggedIn !== isLoggedIn && isBIAABCustomVariableEnabled && isLoggedIn) {
      await BuyItAgainDynamicStore();
      getBIABagPageProducts();
    }
    const { pathname = '' } = (window && window.location) || {};
    if (
      pageName === 'home' &&
      isRegisteredUserCallDone &&
      plccOfferTakeOverABTestEnabled !== null &&
      pathname.indexOf('register') === -1 &&
      pathname.indexOf('login') === -1
    ) {
      this.subscriptionPopUpOnPageLoad();
    }
  }

  componentWillUnmount() {
    const { router } = this.props;
    if (router.events) {
      router.events.off('routeChangeComplete', this.handleRouteChangeComplete);
    }
  }

  subscriptionPopUpOnPageLoad = () => {
    const { openPlccOfferModal, isPlcc, plccModalPersistentCookieExpiry } = this.props;
    const { COOKIE_PLCC_OFFER_MODAL_PERSISTENT } = HOMEPAGE_CONSTANTS;
    /**
     * @function domain check for the domain setting in cookie
     */
    const brand = getBrandInCaps();

    const domain = DOMAIN[brand];

    /**
     * @function checkCookieExist function to check the existence
     * of cookie in the browser by returning @BOOLEAN
     */
    const checkCookieExist = (name) => document.cookie.indexOf(name) > -1;

    /**
     * condition checks for the existence of @cookie COOKIE_EMAIL_PERSISTENT
     * if false, then creates new cookie @cookie COOKIE_EMAIL_PERSISTENT and
     * COOKIE_EMAIL_SESSION and invoke @function openEmailSignUpModal
     * else checks for existence of @cookie COOKIE_EMAIL_PERSISTENT and non-existence
     * of @cookie COOKIE_SMS_PERSISTENT
     * if the above condition evaluates true then invoke
     * @function openSmsSignUpModal and set @cookie COOKIE_SMS_PERSISTENT
     */
    if (
      this.shouldPlccTakeOver() &&
      !isPlcc &&
      !checkCookieExist(COOKIE_PLCC_OFFER_MODAL_PERSISTENT)
    ) {
      document.cookie = `${COOKIE_PLCC_OFFER_MODAL_PERSISTENT}=true; domain=${domain}; max-age=${(
        86400 * plccModalPersistentCookieExpiry
      ).toString()}`;
      openPlccOfferModal();
    }
  };

  shouldPlccTakeOver = () => {
    const { plccOfferTakeOverABTestEnabled } = this.props;
    return plccOfferTakeOverABTestEnabled && !isCanada();
  };

  // For Setting the Home Page Analytics Data.
  sHomePageAnalyticsVal = (router) => {
    const { setCampaignId, trackHomepageView, setClickAnalyticsData, storeId /* currency */ } =
      this.props;
    const queryParams = getQueryParamsFromUrl(router && router.asPath);
    const campaingnId = 'cid';
    const products = internalCampaignProductAnalyticsList();
    const nonSerachStr = 'non-internal search';
    setProp('eVar15', 'D-Vo');

    let analyticsData = {};

    if (queryParams[campaingnId]) {
      setProp('eVar22', `external channel:${queryParams[campaingnId]}` || '');
      setCampaignId(queryParams[campaingnId]);
      analyticsData = {
        customEvents: ['event18'],
        internalCampaignId: '',
        pageSearchText: '',
        pageSearchType: nonSerachStr,
        listingCount: nonSerachStr,
        pageNavigationText: '',
        storeId,
      };
    } else {
      analyticsData = { storeId };
    }
    setClickAnalyticsData(analyticsData);
    // Ticket https://childrensplace.atlassian.net/browse/GMP-318 to remove call
    // Keeping all changes because we may need this call in future
    const productsObj = products && internalPromotionFormattedProducts(products);
    const enableImpressionCall = true;
    if (enableImpressionCall) {
      fireEnhancedEcomm({
        eventName: 'internalcampaignimpression',
        productsObj,
        eventType: 'promoView',
        pageName: 'homepage',
        currCode: 'USD',
      });
    }
    trackHomepageView({
      internalCampaignIdList: products,
      pageName: 'home page',
      pageSection: 'homepage',
      pageSubSection: 'home page',
      pageType: 'home page',
      storeId,
    });
  };

  handleRouteChangeComplete = (url) => {
    if (url && url.indexOf('/register-checkout') !== -1) {
      this.setState({ showLogin: false, showRegister: false, showRegisterCheckout: true });
    } else if (url && url.indexOf('/login') !== -1) {
      this.setState({ showLogin: true, showRegister: false, showRegisterCheckout: false });
    } else if (url && url.indexOf('/register') !== -1) {
      this.setState({ showRegister: true, showLogin: false, showRegisterCheckout: false });
    } else {
      this.setState({ showLogin: false, showRegister: false, showRegisterCheckout: false });
    }
  };

  render() {
    const { children, router, isRegisteredUserCallDone } = this.props;
    const { showRegister, showLogin, showRegisterCheckout } = this.state;
    if (showRegister) {
      return (
        <CreateAccount
          router={router}
          fullPageView
          isRegisteredUserCallDone={isRegisteredUserCallDone}
        />
      );
    }
    if (showLogin) {
      return <LoginContainer router={router} fullPage />;
    }

    if (showRegisterCheckout) {
      return (
        <CreateAccount
          router={router}
          fullPageView
          isRegisteredUserCallDone={isRegisteredUserCallDone}
          isNewRegisteredFlow
        />
      );
    }
    return [children];
  }
}

const HomePageWithRouter = withRouter(HomePageWrapper);

const HomePageView = (compProps) => {
  const {
    emailSignup,
    emailSubscription,
    getPageLayout,
    isEmailModalOpen,
    isSMSModalOpen,
    isEmailSmsModalOpen,
    isPlccOfferModalOpen,
    isRegisteredUserCallDone,
    openCountrySelectorModal,
    openEmailSignUpModal,
    openPlccOfferModal,
    openSmsSignUpModal,
    pageName,
    plccModalPersistentCookieExpiry,
    plccOfferTakeOverABTestEnabled,
    seoData,
    setCampaignId,
    setClickAnalyticsData,
    slots,
    smsSignup,
    openEmailSmsSignUpModal,
    smsSubscription,
    storeId,
    trackHomepageView,
    lazyloadModules,
    allModules,
    isHpNewDesignCTAEnabled,
    isHpNewModuleDesignEnabled,
    isOnScrollAnimationEnabled,
    ssrHomeSlotRenderCount,
    disableVideosForAppleDevice,
    fonts,
    isLoggedIn,
    getBIABagPageProducts,
    isBIAABCustomVariableEnabled,
    isLazyLoadHPModules,
    lazyLoadHPModulesCount,
  } = compProps;
  const { isCandidEnabled, staticAssetHost, isHpNewModuleLoaderDesignEnabled, locale } =
    getAPIConfig();
  const brand = getBrandInCaps();

  const willCandidFeatureDisplay = isCandidEnabled === 'true' && isTier1Device();

  const getHostUrl = () => {
    let homePageUrl = '';

    if (locale === 'es_US') {
      homePageUrl =
        brand === 'GYM' ? 'https://es.gymboree.com/us/' : 'https://es.childrensplace.com/us/';
    } else if (locale === 'en_CA') {
      homePageUrl =
        brand === 'GYM' ? 'https://www.gymboree.com/ca/' : 'https://www.childrensplace.com/ca/';
    } else if (locale === 'fr_CA') {
      homePageUrl =
        brand === 'GYM' ? 'https://fr.gymboree.com/ca/' : 'https://fr.childrensplace.com/ca/';
    } else {
      homePageUrl =
        brand === 'GYM' ? 'https://www.gymboree.com/us/' : 'https://www.childrensplace.com/us/';
    }

    return homePageUrl;
  };

  const ORG_NAME = "The Children's Place";

  const getHomePageSchema = () => {
    if (brand === 'GYM') {
      return {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        '@id': 'https://www.gymboree.com#organization',
        name: 'Gymboree',
        alternateName: 'GYM',
        url: `${getHostUrl()}home`,
        logo: 'https://assets.theplace.com/image/upload/ecom/assets/static/icon/gymboree-logo.svg',
        image: 'https://assets.theplace.com/image/upload/ecom/assets/static/icon/gymboree-logo.svg',
        description:
          'Find timeless hand-me-down quality kids and toddler clothing at Gymboree. Shop boys and girls clothes up to size 12 and discover the magic of coordinating, bow-to-toe clothing.',
        brand: {
          '@type': 'Brand',
          name: 'Gymboree',
        },
        sameAs: [
          'https://www.facebook.com/Gymboree/',
          'https://twitter.com/gymboree',
          'https://www.instagram.com/gymboree/',
          'https://pinterest.com/gymboree',
          'https://www.tiktok.com/@gymboree.official',
          'https://www.youtube.com/channel/UCncPqMkYveNwog--x9g5VVg',
        ],
        founders: {
          '@type': 'Person',
          name: 'Joan Barnes',
        },
        foundingDate: '1976',
        foundingLocation: 'San Francisco, California',
        employee: {
          '@type': 'Person',
          name: 'Umair Muhammad',
          jobTitle: 'Chief Executive Officer',
        },
        address: {
          '@type': 'PostalAddress',
          streetAddress: '500 Plaza Dr',
          addressLocality: 'Secaucus',
          addressRegion: 'NJ',
          postalCode: '07094',
          addressCountry: 'US',
        },
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: '+1-877-752-2387',
          email: 'support@childrensplace.com',
          contactType: 'Customer Service',
          areaServed: 'US',
          availableLanguage: ['English', 'Spanish', 'French'],
          hoursAvailable: [
            {
              '@type': 'OpeningHoursSpecification',
              dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
              opens: '10:00',
              closes: '21:00',
            },
            {
              '@type': 'OpeningHoursSpecification',
              dayOfWeek: ['Saturday', 'Sunday'],
              opens: '09:00',
              closes: '17:00',
            },
          ],
        },

        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          returnPolicyCategory: 'https://schema.org/MerchantReturnFiniteReturnWindow',
          merchantReturnDays: '45',
          returnMethod: 'https://schema.org/ReturnByMail',
          returnFees: 'https://schema.org/FreeReturn',
          refundType: 'https://schema.org/FullRefund',
          merchantReturnLink:
            'https://www.gymboree.com/us/help-center/tracking-return/return-policy',
        },
      };
    }
    return {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      '@id': 'https://www.childrensplace.com#organization',
      name: ORG_NAME,
      alternateName: 'TCP',
      url: `${getHostUrl()}home`,
      logo: 'https://assets.theplace.com/image/upload/ecom/assets/static/icon/tcp-logo.svg',
      image: 'https://assets.theplace.com/image/upload/ecom/assets/static/icon/tcp-logo.svg',
      description:
        'Browse our comfortable baby & kids clothes collection featuring all our stylish and affordable options. Shop now!',
      brand: {
        '@type': 'Brand',
        name: ORG_NAME,
      },
      sameAs: [
        'https://www.facebook.com/childrensplace',
        'https://www.instagram.com/childrensplace/',
        'https://twitter.com/childrensplace',
        'https://www.pinterest.com/childrensplace',
        'https://www.linkedin.com/company/the-childrens-place',
        'https://www.youtube.com/@childrensplacetv',
        'https://www.tiktok.com/@childrensplace',
        'https://en.wikipedia.org/wiki/The_Children%27s_Place',
      ],
      founders: [
        {
          '@type': 'Person',
          name: 'David Pulver',
        },
        {
          '@type': 'Person',
          name: 'Clinton Clark',
        },
      ],
      foundingDate: '1969',
      foundingLocation: 'Hartford, Connecticut',
      employee: {
        '@type': 'Person',
        name: 'Umair Muhammad',
        jobTitle: 'Chief Executive Officer',
      },
      address: {
        '@type': 'PostalAddress',
        streetAddress: '500 Plaza Dr',
        addressLocality: 'Secaucus',
        addressRegion: 'NJ',
        postalCode: '07094',
        addressCountry: 'US',
      },
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+1-877-752-2387',
        email: 'support@childrensplace.com',
        contactType: 'Customer Service',
        areaServed: 'US',
        availableLanguage: ['English', 'Spanish', 'French'],
        hoursAvailable: [
          {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
            opens: '10:00',
            closes: '21:00',
          },
          {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: ['Saturday', 'Sunday'],
            opens: '09:00',
            closes: '17:00',
          },
        ],
      },
      hasMerchantReturnPolicy: {
        '@type': 'MerchantReturnPolicy',
        returnPolicyCategory: 'https://schema.org/MerchantReturnFiniteReturnWindow',
        merchantReturnDays: '45',
        returnMethod: 'https://schema.org/ReturnByMail',
        returnFees: 'https://schema.org/FreeReturn',
        refundType: 'https://schema.org/FullRefund',
        merchantReturnLink:
          'https://www.childrensplace.com/us/help-center/tracking-return/return-policy',
      },
    };
  };

  const getSearchSchema = () => {
    if (brand === 'GYM') {
      return {
        '@context': 'https://schema.org/',
        '@type': 'WebSite',
        name: 'Gymboree',
        url: `${getHostUrl()}home`,
        potentialAction: {
          '@type': 'SearchAction',
          target: `${getHostUrl()}search/{search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      };
    }
    return {
      '@context': 'https://schema.org/',
      '@type': 'WebSite',
      name: "The Children's Place",
      url: `${getHostUrl()}home`,
      potentialAction: {
        '@type': 'SearchAction',
        target: `${getHostUrl()}search/{search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    };
  };

  return (
    <>
      {fonts?.length > 0 && (
        <Head>
          {fonts?.map((font) => {
            return (
              <link rel="stylesheet" href={`${staticAssetHost}/rwd/fonts/inline/${font}.css`} />
            );
          })}
        </Head>
      )}
      <div>
        <script
          type="application/ld+json"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(getHomePageSchema()),
          }}
        />
        <script
          type="application/ld+json"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(getSearchSchema()),
          }}
        />
      </div>
      {isEmailModalOpen && (
        <DynamicModule
          key="sign-up-modals"
          importCallback={() =>
            import(
              /* webpackChunkName: "sign-up-modals" */ '@tcp/web/src/components/common/molecules/EmailSignupModal/container'
            )
          }
          buttonConfig={emailSignup}
          isModalOpen={isEmailModalOpen}
        />
      )}
      {isSMSModalOpen && (
        <DynamicModule
          key="sign-up-modals"
          importCallback={() =>
            import(
              /* webpackChunkName: "sign-up-modals" */ '@tcp/web/src/components/common/molecules/SmsSignupModal/container'
            )
          }
          buttonConfig={smsSignup}
          isModalOpen={isSMSModalOpen}
        />
      )}
      {isEmailSmsModalOpen && (
        <DynamicModule
          key="sign-up-modals"
          importCallback={() =>
            import(
              /* webpackChunkName: "sign-up-modals" */ '@tcp/web/src/components/common/molecules/EmailSmsSignUp/container'
            )
          }
          isModalOpen={isEmailSmsModalOpen}
        />
      )}
      {isPlccOfferModalOpen && (
        <DynamicModule
          key="sign-up-modals"
          importCallback={() =>
            import(
              /* webpackChunkName: "plcc-offer-modal" */ '@tcp/web/src/components/common/molecules/PlccOfferModal/container'
            )
          }
          buttonConfig={emailSignup}
          isModalOpen={isPlccOfferModalOpen}
        />
      )}
      <HomePageWithRouter
        openCountrySelectorModal={openCountrySelectorModal}
        setCampaignId={setCampaignId}
        trackHomepageView={trackHomepageView}
        setClickAnalyticsData={setClickAnalyticsData}
        isRegisteredUserCallDone={isRegisteredUserCallDone}
        storeId={storeId}
        getPageLayout={getPageLayout}
        plccOfferTakeOverABTestEnabled={plccOfferTakeOverABTestEnabled}
        pageName={pageName}
        plccModalPersistentCookieExpiry={plccModalPersistentCookieExpiry}
        compProps={compProps}
        openEmailSignUpModal={openEmailSignUpModal}
        openPlccOfferModal={openPlccOfferModal}
        openSmsSignUpModal={openSmsSignUpModal}
        isEmailModalOpen={isEmailModalOpen}
        isSMSModalOpen={isSMSModalOpen}
        isPlccOfferModalOpen={isPlccOfferModalOpen}
        smsSubscription={smsSubscription}
        emailSubscription={emailSubscription}
        openEmailSmsSignUpModal={openEmailSmsSignUpModal}
        lazyloadModules={lazyloadModules}
        isLoggedIn={isLoggedIn}
        getBIABagPageProducts={getBIABagPageProducts}
        isBIAABCustomVariableEnabled={isBIAABCustomVariableEnabled}
      >
        <StyledPageSlotsWrapper isHpNewModuleDesignEnabled={isHpNewModuleDesignEnabled}>
          <PageSlots
            slots={slots}
            allModules={allModules}
            modules={modules}
            page={HOMEPAGE_CONSTANTS.PAGE_NAME}
            isHomePage
            isHpNewModuleDesignEnabled={isHpNewModuleDesignEnabled}
            isHpNewDesignCTAEnabled={isHpNewDesignCTAEnabled}
            isOnScrollAnimationEnabled={isOnScrollAnimationEnabled}
            ssrHomeSlotRenderCount={ssrHomeSlotRenderCount}
            disableVideosForAppleDevice={disableVideosForAppleDevice}
            isLazyLoadHPModules={isLazyLoadHPModules}
            lazyLoadHPModulesCount={lazyLoadHPModulesCount}
            isHpNewModuleLoaderDesignEnabled={isHpNewModuleLoaderDesignEnabled}
          />
        </StyledPageSlotsWrapper>
        {willCandidFeatureDisplay && <GetCandid isHomePage />}
        <SeoCopy {...seoData} />
      </HomePageWithRouter>
    </>
  );
};

HomePageView.defaultProps = HomePageViewDefaultProps;
HomePageWrapper.defaultProps = HomePageWrapperDefaultProps;
HomePageWrapper.propTypes = HomePageWrapperPropTypes;
HomePageView.propTypes = HomePageViewPropTypes;
const HomePageViewWithErrorBoundary = errorBoundary(HomePageView);

// Wrap the home page with a ref-forwarding element
const RefWrappedHomePageView = withRefWrapper(HomePageViewWithErrorBoundary);

/**
 * Hotfix-Aware Component. The use of `withHotfix` is just for making
 * page hotfix-aware.
 */
RefWrappedHomePageView.displayName = 'HomePage';
const HotfixAwareHomePage = withHotfix(RefWrappedHomePageView);

export default HotfixAwareHomePage;

export { HomePageView as HomePageViewVanilla };
